import { z } from "zod";
import type { DurationInSeconds } from "../date-time/time-spans";
import { durationInSecondsZodSchema } from "../date-time/time-spans";
import type { Translatable } from "../translations/translation";
import {
    translatableZodSchema,
    translatedFactory,
} from "../translations/translation";

const notificationTargets = ["NEW_ORDER", "REMINDER", "ORDER_CHANGE"] as const;
type NotificationTarget = (typeof notificationTargets)[number];
const notificationTargetZodSchema = z.enum(notificationTargets);
type ProductNotification = {
    _type: "PRODUCT_NOTIFICATION";
    sendReminder?: DurationInSeconds;
    productInformationData?: {
        enabled: boolean;
        //Information to be sent to customers in the notification
        title: Translatable;
        subject: Translatable;
        includeInSms?: NotificationTarget[];
    }; // Added as part of the product mail
    sendSmsFor: NotificationTarget[]; //För vilka event ska vi skicka sms för denna produkt.
};

const DefaultProductNotification: ProductNotification = {
    _type: "PRODUCT_NOTIFICATION",
    sendSmsFor: ["NEW_ORDER"],
    productInformationData: {
        enabled: false,
        //Information to be sent to customers in the notification
        title: translatedFactory({ sv: "" }),
        subject: translatedFactory({ sv: "" }),
        includeInSms: [],
    },
};

const productNotificationZodSchema: z.ZodSchema<ProductNotification> = z.object(
    {
        _type: z.literal("PRODUCT_NOTIFICATION"),
        sendReminder: durationInSecondsZodSchema.optional(),
        productInformationData: z
            .object({
                enabled: z.boolean(),
                title: translatableZodSchema,
                subject: translatableZodSchema,
                includeInSms: z.array(notificationTargetZodSchema),
            })
            .optional(),
        sendSmsFor: z.array(notificationTargetZodSchema),
    },
);

export {
    DefaultProductNotification,
    notificationTargetZodSchema,
    productNotificationZodSchema,
};
export type { NotificationTarget, ProductNotification };
